// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"4d8828ad","463":"6dad8380","741":"90848afc","755":"52485c7d","973":"95c62cbb"}[chunkId] + ".chunk.js";
};